module.exports = __webpack_public_path__ + "img/cloud.db692e52.svg";